export default {
    enter_address: 'Please enter your address',
    edit_address: 'Change address',
    enter_address_here: 'Enter your address here',
    buttons: {
        create_new: 'Add new location',
        back: 'Back',
    },
    only_supported_country:
        'Currently, only Serbia and Bosnia and Herzegovina are supported! We are working to expand to others.',
    company_bosnia_country:
        "The company's address is in Bosnia and Herzegovina, and only locations from Bosnia and Herzegovina can be added.",
    company_serbia_country: 'Company address is in Serbia, and only locations from Serbia can be added.',
    deleted_success: 'Location successfully deleted!',
    no_locations: 'You don`t have added locations!',
}
